module.exports = __webpack_public_path__ + "components/flag/static/square/ee-569be01bc0add8bc01021707cb8590e3.svg";